import './style.css'
import * as THREE from 'three'
import {OrbitControls} from 'three/examples/jsm/controls/OrbitControls'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { Color, Vector2, Vector3 } from 'three'
import gsap from 'gsap'
import { mapLinear } from 'three/src/math/MathUtils'


//loadingManager
const loadingBarElement = document.querySelector('.loading-bar')
const loadingManager = new THREE.LoadingManager(
    //loaded
    ()=>
    {
        window.setTimeout(()=>{
            gsap.to(overlayMaterial.uniforms.uAlpha,{duration:3, value:0})
            loadingBarElement.classList.add('ended')
            loadingBarElement.style.transform = ''
            window.setTimeout(()=>{
                scene2.remove(overlay)
            },2000)
        },500)

        
        
    },
    //progress
    (itemUrl,itemsLoaded,itemsTotal)=>
    {
        const progressRatio =  itemsLoaded / itemsTotal
        loadingBarElement.style.transform = `scaleX(${progressRatio})`
    }
)
//variables
const pos = THREE.Vector3
var mouse, raycaster
let deneme = false 
let gameIndex = 0
let oneTime = true
let flag = true



// Scene
const scene = new THREE.Scene()
scene.background = new THREE.Color( 0xffffff )
scene.fog = new THREE.Fog( 0xe0e0e0, 20, 100 )
const scene2 = new THREE.Scene()


//overlay 
const overlayGeometry = new THREE.PlaneBufferGeometry(2,2,1,1)
const overlayMaterial = new THREE.ShaderMaterial({
    transparent:true,
    uniforms:
    {
        uAlpha: {value:1}
    },
    vertexShader: `
    void main()
    {
        gl_Position =  vec4(position, 1.0);
    }
`,
fragmentShader: `
    uniform float uAlpha;
    void main()
    {
        gl_FragColor = vec4(0.0, 0.0, 0.0, uAlpha);
    }
`
})
const overlay = new THREE.Mesh(overlayGeometry,overlayMaterial)
scene.add(overlay)
scene2.add(overlay)


// Texture
const textureLoader = new THREE.TextureLoader(loadingManager)
const bakedTexture = textureLoader.load('baked.jpg')
bakedTexture.flipY = false

const bakedTexture2 = textureLoader.load('floor02.jpg')
bakedTexture2.flipY = false



const gamesTexture = textureLoader.load('games.jpg')
gamesTexture.flipY = false

// Baked material
const bakedMaterial = new THREE.MeshBasicMaterial({ map: bakedTexture})
const bakedMaterial2 = new THREE.MeshBasicMaterial({map: bakedTexture2})
const gamesMaterial = new THREE.MeshBasicMaterial({ map: gamesTexture})
const tempMat = gamesMaterial.clone()
const tempMat1 = gamesMaterial.clone()
const tempMat2 = gamesMaterial.clone()
const tempMat3 = gamesMaterial.clone()
const tempMat4 = gamesMaterial.clone()
const tempMat5 = gamesMaterial.clone()


//Fonts

//Raycaster



//Lights
 
// Group
const cubeX = new THREE.Group()
const cubeO = new THREE.Group()
const cubeV = new THREE.Group()
const cubeS = new THREE.Group()

const fish01 = new THREE.Group()
const fish02 = new THREE.Group()
const fish03 = new THREE.Group()
const fish04 = new THREE.Group()
const fish05 = new THREE.Group()

const _4cube  = new THREE.Group()

const parentGroup = new THREE.Group()
const parentGroup2 = new THREE.Group()



// Object





//#region foobar
// Draco loader

const dracoLoader = new DRACOLoader(loadingManager)
dracoLoader.setDecoderPath('draco/')

// GLTF loader
const gltfLoader = new GLTFLoader()
gltfLoader.setDRACOLoader(dracoLoader)

gltfLoader.load(
    'floor01.glb',
    (gltf) =>
    {
       
        gltf.scene.traverse((child) =>
        {
            child.material = bakedMaterial
        })
        gltf.scene.position.set(4,0,1)   


        parentGroup.add(gltf.scene)
       

    }
)
gltfLoader.load(
    'floor02.glb',
    (gltf) =>
    {
        gltf.scene.traverse((child) =>
        {
            child.material = bakedMaterial2
        })
        gltf.scene.position.set(4,0,1)   
        parentGroup.add(gltf.scene)
    }
)

gltfLoader.load(
    'camera.glb',
    (gltf) =>
    {
        gltf.scene.traverse((child) =>
        {
            child.material = bakedMaterial
        })

        gltf.scene.position.set(4,0,1)
        
        parentGroup.add(gltf.scene)


    }
)
gltfLoader.load(
    'gameFrames01.glb',
    (gltf) =>
    {
        gltf.scene.traverse((child) =>
        {
            child.material = gamesMaterial
        })

        gltf.scene.position.set(4,0,1)
        
        parentGroup2.add(gltf.scene)
       

    }
)
gltfLoader.load(
    'gameFrames02.glb',
    (gltf) =>
    {
        gltf.scene.traverse((child) =>
        {
            child.material = gamesMaterial
        })

        gltf.scene.position.set(4,0,1)
        
       
        parentGroup2.add(gltf.scene)

    }
)
gltfLoader.load(
    'gameFrames03.glb',
    (gltf) =>
    {
        gltf.scene.traverse((child) =>
        {
            child.material = gamesMaterial
        })

        gltf.scene.position.set(4,0,1)
        
       
        parentGroup2.add(gltf.scene)

    }
)
gltfLoader.load(
    'gameFrames04.glb',
    (gltf) =>
    {
        gltf.scene.traverse((child) =>
        {
            child.material = gamesMaterial
        })

        gltf.scene.position.set(4,0,1)
        
       
        parentGroup2.add(gltf.scene)

    }
)
gltfLoader.load(
    'gameFrames05.glb',
    (gltf) =>
    {
        gltf.scene.traverse((child) =>
        {
            child.material = gamesMaterial
        })

        gltf.scene.position.set(4,0,1)
        
       
        parentGroup2.add(gltf.scene)

    }
)
gltfLoader.load(
    'gameFrames06.glb',
    (gltf) =>
    {
        gltf.scene.traverse((child) =>
        {
            child.material = gamesMaterial
        })

        gltf.scene.position.set(4,0,1)
        
       
        parentGroup2.add(gltf.scene)

    }
)
gltfLoader.load(
    'joystickBox01.glb',
    (gltf) =>
    {
        gltf.scene.traverse((child) =>
        {
            child.material = bakedMaterial
        })

        gltf.scene.position.set(4,0,1)
        
        cubeX.add(gltf.scene)
        parentGroup.add(cubeX)


    }
)
gltfLoader.load(
    'joystickBox02.glb',
    (gltf) =>
    {
        gltf.scene.traverse((child) =>
        {
            child.material = bakedMaterial
        })

        gltf.scene.position.set(4,0.3,1)
        
        cubeO.add(gltf.scene)
        parentGroup.add(cubeO)


    }
)

gltfLoader.load(
    'joystickBox03.glb',
    (gltf) =>
    {
        gltf.scene.traverse((child) =>
        {
            child.material = bakedMaterial
        })

        gltf.scene.position.set(4,0,1)
        cubeV.add(gltf.scene)
        parentGroup.add(cubeV)


    }
)
gltfLoader.load(
    'joystickBox04.glb',
    (gltf) =>
    {
        gltf.scene.traverse((child) =>
        {
            child.material = bakedMaterial
        })

        gltf.scene.position.set(4,0,1)
        cubeS.add(gltf.scene)
        parentGroup.add(cubeS)


    }
)
gltfLoader.load(
    'fish01.glb',
    (gltf) =>
    {
        gltf.scene.traverse((child) =>
        {
            child.material = bakedMaterial2
        })

        gltf.scene.position.set(4,0,1)
        fish01.add(gltf.scene)
        parentGroup2.add(fish01)


    }
)
gltfLoader.load(
    'fish02.glb',
    (gltf) =>
    {
        gltf.scene.traverse((child) =>
        {
            child.material = bakedMaterial2
        })

        gltf.scene.position.set(4,0,1)
        fish02.add(gltf.scene)
        parentGroup2.add(fish02)


    }
)
gltfLoader.load(
    'fish03.glb',
    (gltf) =>
    {
        gltf.scene.traverse((child) =>
        {
            child.material = bakedMaterial2
        })

        gltf.scene.position.set(4,0,1)
        fish03.add(gltf.scene)
        parentGroup2.add(fish03)


    }
)
gltfLoader.load(
    'fish04.glb',
    (gltf) =>
    {
        gltf.scene.traverse((child) =>
        {
            child.material = bakedMaterial2
        })

        gltf.scene.position.set(4,0,1)
        fish04.add(gltf.scene)
        parentGroup2.add(fish04)


    }
)
gltfLoader.load(
    'fish05.glb',
    (gltf) =>
    {
        gltf.scene.traverse((child) =>
        {
            child.material = bakedMaterial2
        })

        gltf.scene.position.set(4,0,1)
        fish05.add(gltf.scene)
        parentGroup2.add(fish05)


    }
)
gltfLoader.load(
    'flower.glb',
    (gltf) =>
    {
        gltf.scene.traverse((child) =>
        {
            child.material = bakedMaterial
        })

        gltf.scene.position.set(4,0,1)
        
       
        parentGroup.add(gltf.scene)


    }
)
gltfLoader.load(
    'up.glb',
    (gltf) =>
    {
        gltf.scene.traverse((child) =>
        {
            child.material = bakedMaterial2
        })

        gltf.scene.position.set(4,0,1)
        
       
        parentGroup2.add(gltf.scene)


    }
)
gltfLoader.load(
    'down.glb',
    (gltf) =>
    {
        gltf.scene.traverse((child) =>
        {
            child.material = bakedMaterial2
        })

        gltf.scene.position.set(4,0,1)
        
       
        parentGroup2.add(gltf.scene)


    }
)
gltfLoader.load(
    '4cube.glb',
    (gltf) =>
    {
        gltf.scene.traverse((child) =>
        {
            child.material = bakedMaterial2
        })

        gltf.scene.position.set(4,0,1)
        
       
        parentGroup2.add(gltf.scene)


    }
)

scene.add(parentGroup)
scene2.add(parentGroup2)
//#endregion

//canvas
const canvas = document.querySelector('canvas.webgl')
//axes helper

// Sizes
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
    
}
window.addEventListener('dblclick', ()=>{

    const fullscreenElement = document.fullscreenElement || document.webkitFullscreenElement

    if(!fullscreenElement){
        if(canvas.requestFullscreen){
            canvas.requestFullscreen()
        }else if(canvas.webkitRequestFullscreen){
            canvas.webkitRequestFullscreen()
        }
    }else{

        if (document.exitFullscreen) {
            document.exitFullscreen()
        }else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen()
        }

        
    }
})

window.addEventListener('resize',()=>{
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio,2))
} )

window.addEventListener('click',function(e){
    if(deneme){
        if (gameIndex == 1) {
            window.open('https://play.google.com/store/apps/details?id=com.fnstudio.circularmaze&hl=tr&gl=US','_blank');
        }
        if (gameIndex == 2) {
            window.open('https://play.google.com/store/apps/details?id=com.fnstudio.meltmaster','_blank');
        }
        if (gameIndex == 3) {
            window.open('https://play.google.com/store/apps/details?id=com.fnstudio.ballsandhands&hl=tr&gl=US','_blank');
        }
        if (gameIndex == 4) {
            window.open('https://play.google.com/store/apps/details?id=com.fnstudio.sandcastle','_blank');
        }
        if (gameIndex == 5) {
            window.open('https://play.google.com/store/apps/details?id=com.fnstudio.dogshow','_blank');
        }
        if (gameIndex == 6) {
            window.open('https://play.google.com/store/apps/details?id=com.fnstudio.funsimulation&hl=tr&gl=US','_blank');
        }
        if (gameIndex == 7) {
            ChangePosFloor2()
        }
        if (gameIndex == 8) {
            ChangePosFloor1()
        }
     
    
    }
})
// Camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height)
camera.position.set(-4,3,4)
scene.add(camera)

//Controls
const controls = new OrbitControls(camera,canvas)
controls.enableDamping = true
controls.maxAzimuthAngle  = 2*Math.PI 
controls.minAzimuthAngle = -2*Math.PI*4/3
controls.maxPolarAngle = Math.PI/2; 
controls.minPolarAngle = 0
controls.enablePan = false

controls.minDistance = 2
controls.maxDistance = 5.5


// Renderer
const renderer = new THREE.WebGLRenderer({
    canvas: document.querySelector('canvas.webgl')
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio,2))

raycaster = new THREE.Raycaster();
mouse = new THREE.Vector2();

//clocks
const clock = new THREE.Clock()

//animations
gsap.to(cubeX.position,{duration:.5,delay:0,y:.3,repeat:-1,yoyo:true})
gsap.to(cubeO.position,{duration:.5,delay:0,y:-0.3,repeat:-1,yoyo:true})
gsap.to(cubeV.position,{duration:.5,delay:0,y:0.3,z:0.1,repeat:-1,yoyo: true})
gsap.to(cubeS.position,{duration:.5,delay:0,y:0.3,z:-0.1,repeat:-1,yoyo: true})
gsap.to(fish01.position,{duration:25,delay:0,z:-1.3,repeat:-1})
gsap.to(fish02.position,{duration:25,delay:0,z:-1.3,repeat:-1})
gsap.to(fish03.position,{duration:25,delay:0,z:1.3,repeat:-1})
gsap.to(fish04.position,{duration:25,delay:0,z:-1.3,repeat:-1})
gsap.to(fish05.position,{duration:25,delay:0,z:1.3,repeat:-1})



function ChangePosFloor2() {
    gsap.to(parentGroup.position,{duration:1,delay:0,y:-5,x:-6,z:1})
    gsap.to(parentGroup2.position,{duration:1,delay:0,y:-5,x:-6,z:1})

}
function ChangePosFloor1() {
    gsap.to(parentGroup.position,{duration:1,delay:0,y:0,x:0,z:0})
    gsap.to(parentGroup2.position,{duration:1,delay:0,y:0,x:0,z:0})
   
}


function hoverObjects(){
    raycaster.setFromCamera(mouse,camera)
    const intersects = raycaster.intersectObjects(scene2.children)
     for (let i = 0; i < intersects.length; i++) {
        
        if (intersects[i].object.name == "gameFrames01") {
            
            tempMat.transparent = true;
            tempMat.opacity = 0.5;
            intersects[i].object.material = tempMat;
            deneme = true;
            gameIndex = 1;
            
            
        }
      }
    for (let i = 0; i < intersects.length; i++) {
        if (intersects[i].object.name == "gameFrames01") {
            
            tempMat.transparent = true;
            tempMat.opacity = 0.5;
            intersects[i].object.material = tempMat;
            deneme = true;
            gameIndex = 1;
            
            
        }
      }
      for (let i = 0; i < intersects.length; i++) {
        if (intersects[i].object.name == "gameFrames02") {
            tempMat1.transparent = true;
            tempMat1.opacity = 0.5;
            intersects[i].object.material = tempMat1;
            deneme = true;
            gameIndex = 2;
        }
      }
      for (let i = 0; i < intersects.length; i++) {
        if (intersects[i].object.name == "gameFrames03") {
            tempMat2.transparent = true;
            tempMat2.opacity = 0.5;
            intersects[i].object.material = tempMat2;
            deneme = true;
            gameIndex = 3;
        }
      }
      for (let i = 0; i < intersects.length; i++) {
        if (intersects[i].object.name == "gameFrames04") {
            tempMat3.transparent = true;
            tempMat3.opacity = 0.5;
            intersects[i].object.material = tempMat3;
            deneme = true;
            gameIndex = 4;
        }
      }
      for (let i = 0; i < intersects.length; i++) {
        if (intersects[i].object.name == "gameFrames05") {
            tempMat4.transparent = true;
            tempMat4.opacity = 0.5;
            intersects[i].object.material = tempMat4;
            deneme = true;
            gameIndex = 5;
        }
      }
      for (let i = 0; i < intersects.length; i++) {
        if (intersects[i].object.name == "gameFrames06") {
            tempMat5.transparent = true;
            tempMat5.opacity = 0.5;
            intersects[i].object.material = tempMat5;
            deneme = true;
            gameIndex = 6;
        }
      }
      for (let i = 0; i < intersects.length; i++) {
        if (intersects[i].object.name == "ChamferBox024") {
            deneme = true;
            gameIndex = 7;
        }
      }
      for (let i = 0; i < intersects.length; i++) {
        if (intersects[i].object.name == "ChamferBox025") {
            deneme = true;
            gameIndex = 8;
            
        }
      }
      
      if(intersects.length == 0){
        tempMat.opacity = 1.0
        tempMat1.opacity = 1.0
        tempMat2.opacity = 1.0
        tempMat3.opacity = 1.0
        tempMat4.opacity = 1.0
        tempMat5.opacity = 1.0
        deneme = false
      }
    
}


const tick = () =>{


 
    
   //update camera
    hoverObjects()
   // camera.position.y +=0.1
   
    const elapsedTime = clock.getElapsedTime()
    controls.update()
    renderer.autoClear = true;

    //render scene1
    renderer.render(scene, camera);

    //prevent canvas from being erased with next .render call
    renderer.autoClear = false;

    //just render scene2 on top of scene1
    renderer.render(scene2, camera);
    window.requestAnimationFrame(tick)
}

function onMouseMove(event) {
 
    // calculate mouse position in normalized device coordinates
    // (-1 to +1) for both components
 
    mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
    mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
   
 
}

window.addEventListener('mousemove', onMouseMove, false);

tick()